import React from 'react';
import ProductPage from '../components/ProductPage';
import { DALCOMM_EMBRY_RIDDLE_IMAGES } from '../data/dalcomm';

const DalcommEmbryRiddleHeadsetPage = ({ onRequestDemo, onRequestQuote }) => {
  const productData = {
    productName: 'Embry-Riddle Aviation Headset',
    partNumber: 'DALCOMM-ERAU',
    tagline: 'Leave the Noise Behind, and Enjoy the Flight.',
    description:
      "The Embry-Riddle Aviation Headset is the standard model made better in every way. Familiar style, built with the options and features today's student pilots and instructors actually ask for — interchangeable cords, your choice of ear seals, your choice of microphone, and personalization. Customers can request their name, tail number, or call sign added to the headset by emailing sales@dalcommtech.com.",
    image: DALCOMM_EMBRY_RIDDLE_IMAGES[0],
    images: DALCOMM_EMBRY_RIDDLE_IMAGES,
    imageContain: true,
    features: [
      {
        title: 'Interchangeable Cord System',
        description:
          'Swap the cord to match the aircraft you are flying — fixed-wing twin plugs, helicopter (straight or coiled), 5-pin Airbus XLR, or USB Type-A for training and sim.',
      },
      {
        title: '3.5 mm Auxiliary Audio Input',
        description:
          'Onboard aux input for streaming music, briefings, or checklist audio from a phone or tablet.',
      },
      {
        title: 'Full-Flex Mic Boom — 270° Rotation',
        description:
          'Boom rotates 270° so the headset can be worn on either side — right- or left-handed, day one.',
      },
      {
        title: 'Your Choice of Ear Seals',
        description:
          'Foam, gel, gel + foam, or protein leather ear seals — configure at checkout, not months later.',
      },
      {
        title: 'Noise-Cancelling Amplified Electret Microphone',
        description:
          'Amplified electret mic with noise cancelling — clean transmit audio through radio, sim, or ATC.',
      },
      {
        title: 'Volume Control Knobs',
        description:
          'Independent per-cup volume control knobs — trim each ear separately for hearing asymmetry or one-side ATC monitoring.',
      },
      {
        title: '65-Month Manufacturer Warranty',
        description:
          'Standard 65-month manufacturer warranty on the headset — designed to last through primary training and beyond.',
      },
      {
        title: 'Add Personalization',
        description:
          "Add your name, tail number, or call sign — email sales@dalcommtech.com when ordering.",
      },
    ],
    specifications: [
      { label: 'Weight', value: '0.5 lb (227 g)' },
      { label: 'Dimensions', value: '12 × 12 × 6 in' },
      { label: 'Warranty', value: '65 months manufacturer warranty' },
      { label: 'Connection Options', value: 'Twin plugs (fixed wing) · Helicopter (straight or coiled) · 5-pin Airbus XLR · USB Type-A' },
      { label: '10% Off Second Cable', value: 'SBJ-1 / SBJ-2 / SBJ-15 / SBJ-12 (+$70) · SBJ-USB (+$116)' },
      { label: 'Ear Seals', value: 'Foam · Gel · Gel + Foam · Protein Leather' },
      { label: 'Microphone', value: 'Noise-cancelling amplified electret' },
      { label: 'Aux Input', value: '3.5 mm auxiliary audio input' },
      { label: 'Price Range', value: '$369 – $573 depending on configuration' },
    ],
    applications: [
      'Primary flight training at Embry-Riddle and other collegiate programs',
      'Private pilot / instrument / commercial training',
      'Fixed-wing GA operations',
      'Helicopter training and operations',
      'Airbus 5-pin XLR aircraft',
      'USB training and simulator operation',
    ],
  };

  return <ProductPage {...productData} onRequestDemo={onRequestDemo} onRequestQuote={onRequestQuote} />;
};

export default DalcommEmbryRiddleHeadsetPage;
